import { useState } from 'react';
import Modal from 'react-modal';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import './App.css';

const SCREEN_WIDTH = window.innerWidth;

const responsive = {
    superLargeDesktop: {
        breakpoint: { max: 4000, min: 1601 },
        items: 1,
    },
    desktop: {
        breakpoint: { max: 1600, min: 1025 },
        items: 1,
    },
    tablet: {
        breakpoint: { max: 1024, min: 769 },
        items: 1,
    },
    mobile: {
        breakpoint: { max: 768, min: 0 },
        items: 1,
    },
};

const images = [
    'vision1.png',
    'vision2.png',
    'vision3.png',
    'vision4.png',
    'vision5.png',
    'vision6.png',
    'vision7.png',
    'vision8.png',
    'vision9.png',
    'vision10.png',
    'vision11.png',
    'aerial-view.png',
];

Modal.setAppElement('#root');

function App() {
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);
    const [showArrows, setShowArrows] = useState(true);
    const [autoPlay, setAutoPlay] = useState(true);

    function openModal(index: number) {
        setAutoPlay(false);
        setShowArrows(false);
        setModalIsOpen(true);
        setActiveIndex(index);
    }

    function closeModal() {
        setAutoPlay(true);
        setShowArrows(true);
        setModalIsOpen(false);
    }

    return (
        <div className="App">
            <header className="App-background">
                <Modal
                    isOpen={modalIsOpen}
                    onRequestClose={() => closeModal()}
                    contentLabel="Gillis Park's Vision"
                    style={{
                        content: {
                            left: '50%',
                            transform: 'translate(-50%)',
                            backgroundColor: 'rgba(0, 0, 0, 0)',
                            width: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            borderWidth: 0,
                        },
                    }}
                >
                    <div className="active-carousel-image-container">
                        <img
                            src={images[activeIndex]}
                            alt={`Gillis Park ${activeIndex}`}
                            className="active-carousel-image"
                        />
                        <img
                            src={'close-button.png'}
                            style={{
                                position: 'absolute',
                                width: 20,
                                height: 20,
                                top: SCREEN_WIDTH > 768 ? 0 : 15,
                                right: SCREEN_WIDTH > 768 ? 30 : 15,
                            }}
                            onClick={() => closeModal()}
                            className="close-button"
                        />
                    </div>
                </Modal>
                <div className="App-container">
                    <div className="App-logo-background">
                        <img src={'logo.png'} className="App-logo" alt="logo" />
                    </div>
                    <div className="divider"></div>
                    <h1>Mission Statement</h1>
                    <p className="paragraph mission-statement">
                        Our mission is to revitalize and transform Gillis Park into a vibrant, inclusive green oasis
                        which will welcome visitors of all abilities. We aim to honor our veterans while promoting
                        equity, unity and the well being of all citizens. By offering an immersive experience that
                        deepens understanding of the park's surroundings, we hope to foster neighborhood pride and
                        encourage a deeper connection between residents and this cherished public space. We are
                        committed to ensure every member of the community has equal access to a safe, beautiful public
                        park where they can connect with one another and contemplate their shared history, while
                        enjoying breathtaking sunsets and the serene natural beauty of this riverside locale for
                        generations to come.
                    </p>
                    <p className="paragraph survey-alert">
                        Your feedback means a lot! Please take our{' '}
                        <a
                            className="clickable-link"
                            href="https://forms.gle/WGPWJaKEVLdMLYGo7"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            survey
                        </a>
                        !
                    </p>
                    <div className="divider"></div>
                    <h1>Our Plans</h1>
                    <Carousel
                        responsive={responsive}
                        autoPlay={autoPlay}
                        autoPlaySpeed={7000}
                        infinite={true}
                        arrows={showArrows}
                        containerClass="carousel-container"
                        itemClass="carousel-item"
                    >
                        {images.map((src, index) => (
                            <div key={index} style={{ padding: '10px' }}>
                                <img
                                    src={src}
                                    alt={`Gillis Park ${index + 1}`}
                                    style={{ width: '100%', borderRadius: '10px' }}
                                    onClick={() => openModal(index)}
                                />
                            </div>
                        ))}
                    </Carousel>
                    <p className="paragraph">
                        As friends of Gillis Park, we believe that now is a crucial time to re-imagine this public space
                        in order to ensure its continued vitality as well enhance its ultimate contribution to Beverly's
                        future well-being. We feel that the park could better honor the war heroes for which it is
                        named. We hope to create a more impactful and noticeable entrance to the park as a means to
                        honor the local veterans who have made the ultimate sacrifice. We envision better lighting,
                        landscaping, and historical references to augment the current memorial which is overgrown and
                        difficult to view. It is also our hope to enrich the park's serene atmosphere and breathtaking
                        views, in order to make this stretch of land a more frequent and beloved destination for all
                        individuals. We envision a more inviting public space for not only dog walkers, but for
                        fishermen, bird watchers, beach goers, kayakers, and children enjoying new playground equipment.
                        By investing in Gillis Park, the community will not only demonstrate a strong commitment to the
                        overall well being of all of its residents, but will create a more inviting and easily
                        accessible common space for all to enjoy.
                    </p>
                    <div className="divider"></div>
                    <h1 className="upcoming-events-label">Upcoming Events</h1>
                    <h2>Goat Hill Pub Crawl - October 3rd, 2:00 PM</h2>
                    <p className="paragraph">
                    Please join us for the third annual pub crawl to benefit Gillis Park! The crawl will start at 2pm Saturday, October 3rd. A Goat Hill pub crawl tee shirt will be included with your $25 donation for inclusion in the event! Free pizza and fun raffles will be offered to all! Stay tuned for updates on the venues we will be attending this year!
                    </p>
                    <img src="tshirt.png" className="pub-crawl-shirt" alt="Goat Hill Pub Crawl tee shirt" />
                </div>
                <div className="footer">
                    <div className="social-media-row">
                        <a href="https://www.instagram.com/friendsofgillis/" target="_blank" rel="noopener noreferrer">
                            <img src={'instagram-logo.png'} className="social-media-logo" alt="instagram" />
                        </a>
                        <a href="https://www.facebook.com/friendsofgillis/" target="_blank" rel="noopener noreferrer">
                            <img src={'facebook-logo.png'} className="social-media-logo" alt="logo" />
                        </a>
                    </div>
                    <p className="copyright">&#169; Friends of Gillis Park 2026</p>
                </div>
            </header>
        </div>
    );
}

export default App;
